require("../polyfills/element.matches");
require("../polyfills/element.closest");
require("../polyfills/string.includes");

module.exports = function(options) {

    const _this = this;
    const urlNavTreeInfo = options.urlNavTreeInfo || "";
    const urlNavTreeLevel = options.urlNavTreeLevel || "";
    const urlNavTreeInfoContent = options.urlNavTreeInfoContent || "";
    const urlNavTreeConf = options.urlNavTreeConf || "";
    const urlUsageLog = options.urlUsageLog;
    const surveysUrl = (options.surveysUrl || "") + "/data";
    const events = require("../helpers/events");
    const Swal = require("sweetalert2");
    const treeId = 0;
    let breadcrumbLabels = {};
    let navTreeStartLevel = options.origin || "top";
    let navTreeStartNode = options.startNode;
    let navTreeActiveNode = navTreeStartNode;
    let navTreeCurrentLevel = 1;
    let navTreeLevelsCache = {};
    let fullHierarchyMode = false;
    let navTreeCurrentDepth = 1;
    let element;
    let navtreeOn;
    let navtreeOff;
    let breadcrumbs;
    let backdrop;
    let hooks = {
        onReady: []
    }
    const fullHierarchyPath = [];

    this.onReady = function(fn) {
        hooks.onReady.push(fn);
        return this;
    };

    this.addBreadCrumbLabel = function(nodeId, label, replaceExisting) {
        breadcrumbLabels[nodeId] = breadcrumbLabels[nodeId] === undefined || replaceExisting ? label : breadcrumbLabels[nodeId];
    }

    this.createTitleSpanFromCache = function(nodeId) {
        const span = document.createElement("span");
        span.innerHTML = breadcrumbLabels[nodeId] || "";
        return span;
    };

    this.addCrumb = function(elem, tree, level, levelId) {
        let thisListItem = elem;

        // Build the new Breadcrumb element with a click that triggers the 'navigateBackToCrumb' function
        let dataLevelToAdd = level;
        let directoryTitle = thisListItem.getElementsByTagName("span")[0];
        let directoryLogo = thisListItem.getElementsByTagName("svg")[0];
        const directoryTitleSpan = directoryTitle ? directoryTitle.cloneNode(true) : _this.createTitleSpanFromCache(levelId);
        directoryTitleSpan.classList.add("crumb", levelId);
        directoryTitleSpan.dataset.level = dataLevelToAdd;
        directoryTitleSpan.dataset.tree = tree;

        const crumbIcon = directoryTitleSpan.querySelector('svg');
        if (crumbIcon) {
            crumbIcon.remove();
        }

        const thisBreadcrumb = breadcrumbs[tree].getElementsByTagName("ol")[0];
        const crumb = document.createElement("li");

        crumb.dataset.levelId = levelId;
        crumb.dataset.depth = level;

        // Add the new crumb to the end of the list
        if (directoryLogo) {
            crumb.appendChild(directoryLogo.cloneNode(true));
        }
        crumb.appendChild(directoryTitleSpan);
        if (this.isThisBreadcrumbNew(crumb, tree)) {
            thisBreadcrumb.appendChild(crumb);
        }
    };

    this.isThisBreadcrumbNew = function(elem, tree) {
        const thisBreadCrumb = breadcrumbs[tree];
        const crumbsToCheck = thisBreadCrumb.getElementsByTagName("li");
        const crumbsToCheckAmount = crumbsToCheck.length;

        // Check if the crumb passed into this function is the same as one already in the list
        for (let crumbIndex = 0; crumbIndex < crumbsToCheckAmount; crumbIndex++) {
            if (elem.isEqualNode(crumbsToCheck[crumbIndex])) {
                return false;
            }
        }

        // If there is no matching breadcrumb, it is assumed the elem passed in is 'new' and safe to add, so this returns TRUE.
        return true;
    };

    this.sweepRedundantCrumbs = function() {
        const breadcrumbTrail = breadcrumbs[0].getElementsByTagName("li");
        const breadcrumbTrailLength = breadcrumbTrail.length;
        const breadcrumbHolder = breadcrumbTrail[0].parentNode;

        for (let crumbIndex = breadcrumbTrailLength - 1; crumbIndex > 0; crumbIndex--) {
            breadcrumbHolder.removeChild(breadcrumbTrail[crumbIndex]);
        }
        _this.buildBreadcrumbStuctureTo(navTreeCurrentLevel);
        return _this;
    };

    this.sweepLegacyRedundantCrumbs = function(tree, level) {
        const breadcrumbTrail = breadcrumbs[tree].getElementsByTagName("li");
        const breadcrumbTrailLength = breadcrumbTrail.length;
        const breadcrumbHolder = breadcrumbTrail[0].parentNode;

        for (let crumbIndex = breadcrumbTrailLength - 1; crumbIndex > level; crumbIndex--) {
            breadcrumbHolder.removeChild(breadcrumbTrail[crumbIndex]);
        }
        return this;
    };

    this.buildLegacyBreadcrumbStucture = function(levelId) {
        const breadcrumbTrail = document.getElementById("breadcrumb").getElementsByTagName("li");
        const breadcrumbTrailLength = breadcrumbTrail.length;
        let levelNode;

        for (let crumbIndex = 0; crumbIndex < breadcrumbTrailLength; crumbIndex++) {
            levelNode = breadcrumbTrail[crumbIndex].querySelector(".crumb");
            if (levelNode.dataset.levelId === undefined) {
                continue;
            }
            _this.addCrumb(levelNode, treeId, levelNode.dataset.level, levelNode.dataset.levelId);

            if (levelNode.dataset.levelId === levelId) {
                return _this;
            }
        }

        return _this;
    };

    this.getElement = function() {
        return element;
    };

    this.setFullHierarchyMode = function(value) {
        fullHierarchyMode = !!value;
        return this;
    };

    this.getDestinationDepth = function(destinationLevelId) {
        if (destinationLevelId === "top") {
            return 1;
        }

        return destinationLevelId.split("_").length + 1;
    };

    this.inHierarchy = function(elem, levelId) {
        const levels = levelId.split("_");
        const routeNode = elem.id.replace("category-tree-", "").split("_");

        return levels[0] === routeNode[0];
    };

    this.navTreeJumpToLevel = function(levelId, bigJump) {
        if (levelId !== "top") {
            this.usageLog(levelId);
        }

        const destinationDepth = this.getDestinationDepth(levelId);

        element.dataset.currentLevel = destinationDepth;
        navTreeCurrentLevel = levelId;
        this.buildHierarchyStructureTo(levelId);
        this.sweepRedundantCrumbs();
        this.buildBreadcrumbStuctureTo(levelId);
        this.showRootLevelPlaceHolder("none");
        this.showNavTreeBreadCrumbContainer("block");

        let openLevels = element.querySelectorAll(".open");
        for (let i in openLevels) {
            if (openLevels[i].dataset && !_this.inHierarchy(openLevels[i], levelId)) {
                openLevels[i].classList.remove("open");
            }
        }

        let destinationLevel = document.getElementById("nt_node_" + levelId);
        if (destinationLevel) {
            destinationLevel.closest(".tree-nav-dir").classList.add("open");
        }

        if (levelId === "top") {
            this.setBackButtonVisibility(levelId);
            this.showRootLevelPlaceHolder("block");
            this.showNavTreeBreadCrumbContainer("none");
            return Promise.resolve();
        }

        return this.loadLevel(levelId, bigJump);
    };

    this.loadLevel = function(levelId, bigJump) {
        const subMenu = this.getSubLevelElement(levelId);
        if (bigJump) {
            subMenu.parentNode.classList.remove("open");
            const openedNodes = subMenu.parentNode.parentNode.parentNode.getElementsByClassName('open');
            for (let item of openedNodes) {
                item.classList.remove("open");
            }
        }

        return this.getNodeData(levelId)
            .then(function(levelHtml) {
                if (bigJump) {
                    subMenu.parentNode.classList.add("open");
                }
                subMenu.innerHTML = levelHtml;

                // Fill in any missing breadcrumb labels from the response and refresh the UI.
                subMenu.querySelectorAll('[data-breadcrumb-key]').forEach(elem => {
                    const level = elem.dataset.breadcrumbKey;
                    const label = elem.dataset.breadcrumbLabel;

                    _this.addBreadCrumbLabel(level, label, false);
                    document.querySelectorAll(`#nav-tree-popout-breadcrumb .crumb.${level}`).forEach(el => {
                        el.innerHTML = breadcrumbLabels[level];
                    });
                });

                navTreeLevelsCache[levelId] = levelHtml;

                _this.highlightActiveNode(_this.getActiveNodeMenuElement());
                _this.setBackButtonVisibility(levelId);
            });
    };

    this.showRootLevelPlaceHolder = function(property) {
        document.getElementById("root-level-placeholder").style.display = property;
    };

    this.showNavTreeBreadCrumbContainer = function(property) {
        document.getElementById("nav-tree-popout-breadcrumb").style.display = property;
    };

    this.setBackButtonVisibility = function(levelId) {
        document.getElementById("nav-tree-back")
            .closest('.back').style.display = (_this.navTreeGetParentLevel(levelId) ? "" : "none");
    };

    this.getNodeData = function(levelId) {
        // If in cache, return an immediately resolving Promise
        if (navTreeLevelsCache[levelId]) {
            return new Promise(function(resolve) {
                resolve(navTreeLevelsCache[levelId]);
            })
        }

        // Otherwise return a promise that resolves after successful ajax.
        return this.navTreeGetSubnodes(levelId);
    };

    this.usageLog = function(id) {
        if (urlUsageLog === null) {
            return;
        }
        const xhttp = new XMLHttpRequest();
        xhttp.open("POST", urlUsageLog, true);
        xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

        xhttp.send("id=" + id);
    }

    this.navTreeGetSubnodes = function(levelId) {
        return new Promise(function(resolve, reject) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", urlNavTreeLevel + levelId, true);
            xhttp.send(null);

            xhttp.onload = function() {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    const result = JSON.parse(xhttp.responseText);
                    if (result.html === undefined) {
                        reject("Unexpected output");
                        return;
                    }
                    resolve(result.html);
                }
            };
        });
    };

    this.getModalUrl = function(nodeId, context, surveysSource) {
        if (context === 'info') {
            if (surveysSource) {
                return urlNavTreeInfoContent.replace(':node_id', nodeId).replace(':info_id', surveysSource);
            }
        } else if (context === 'source') {
            if (surveysSource) {
                return urlNavTreeSource.replace(':node_id', nodeId).replace(':source_id', surveysSource);
            }
        } else if (context === 'forbidden') {
            return urlNavTreeConf;
        }

        return urlNavTreeInfo + nodeId
    };

    this.fireModal = function(nodeId, context, surveysSource) {
        const xhttp = new XMLHttpRequest();
        const url = this.getModalUrl(nodeId, context, surveysSource);

        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                const result = _this.parseResult(JSON.parse(this.responseText), context, nodeId);
                if (result.id || result.content) {
                    // info icon content is under result.icons.info.content
                    let d = new Date();
                    let ds = d.getFullYear() + "" + d.getMonth() + "" + d.getUTCDate();

                    let icon = (result.logo_icon ? '<svg class="mvl modal-icon"><use href="/_mvl.svg?v=' + ds + '#' + result.logo_icon + '"></use></svg>' : "");
                    let htmlData = '';
                    if (surveysSource || context === 'forbidden') {
                        htmlData = result.content
                    } else {
                        if (!result.icons || !result.icons[context]) {
                            return;
                        }
                        htmlData = result.icons[context].content
                    }

                    Swal.fire({
                        title: icon + result.label,
                        html: htmlData,
                        customClass: {
                            header: "swal2-header " + result.id.split("_").shift()
                        },
                        showClass: {
                            popup: "navtree-modal-popup-shown",
                            backdrop: "navtree-modal-backdrop-shown"
                        },
                        hideClass: {
                            popup: "",
                            backdrop: ""
                        },
                        showCloseButton: true,
                        showConfirmButton: false,
                        focusConfirm: false,
                        willOpen: function() {
                            const mainOverlay = document.getElementById("mainOverlay");
                            if (mainOverlay) mainOverlay.style.display = "none";

                        },
                        willClose: () => {
                            const mainOverlay = document.getElementById("mainOverlay");
                            if (mainOverlay) mainOverlay.style.display = "none";
                            window.event.navtree = {
                                closeNavTree: false
                            };
                        }
                    });
                    jQuery(".swal2-container").css('background', 'rgba(1,1,1,0.5)');
                }
            }
        };
        xhttp.open("POST", url, true);
        xhttp.send();
    };

    this.parseResult = function(data, context, nodeId) {
        if (context !== 'forbidden') {
            return data;
        }

        let result = {};
        result.id = nodeId;
        result.icon = nodeId;
        result.content = data.forbidden_area_txt;
        result.label = data.forbidden_area_title;

        return result;
    };

    this.navTreeInfoModal = function(nodeId, base) {
        _this.fireModal(nodeId, "info", base);
    };

    this.navTreeForbiddenModal = function(nodeId, base) {
        _this.fireModal(nodeId, "forbidden", base);
    };

    this.navTreeSourceModal = function(nodeId, source) {
        _this.fireModal(nodeId, "source", source);
    };

    this.getFullHierarchyPath = function() {
        return fullHierarchyPath;
    };

    this.setFullHierarchyPath = function(nodeIds) {
        fullHierarchyPath.length = 0;
        this.appendFullHierarchyPath(nodeIds);
        return this;
    };

    this.appendFullHierarchyPath = function(nodeIds) {
        fullHierarchyPath.push.apply(fullHierarchyPath, nodeIds);
        return this;
    };

    this.navTreeGetParentLevel = function(levelId) {
        if (levelId === "top") {
            // top has no parent
            return null;
        }
        if (levelId.search("_") === -1) {
            return "top";
        }

        let levels = levelId.split("_");
        levels.pop();
        return levels.join("_");
    };

    this.navTreeJumpToParentLevel = function() {
        const parentLevel = _this.navTreeGetParentLevel(navTreeCurrentLevel);
        if (!parentLevel) {
            return;
        }
        _this.navTreeJumpToLevel(parentLevel);
    };

    this.insertAfter = function(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };

    this.getSubLevelElement = function(nodeId) {
        let subMenu = document.getElementById("nt_submenu_" + nodeId);
        if (subMenu) {
            return subMenu;
        }

        let currentLevelElem = document.getElementById("nt_node_" + nodeId);
        subMenu = document.createElement("div");

        _this.insertAfter(currentLevelElem, subMenu);
        subMenu.id = "nt_submenu_" + nodeId;
        subMenu.classList.add("sub-menu");

        return subMenu;
    };

    this.traverseForwardDelegatedEvent = function(event) {
        if (event.target.closest(".tree-nav-q")) {
            return;
        }
        if (event.target.matches("[data-info]")) {
            return;
        }
        if (event.target.matches("[data-source]")) {
            return;
        }
        event.preventDefault();

        fullHierarchyMode = false;

        if (this.dataset.nodeId) {
            _this.navTreeJumpToLevel(this.dataset.nodeId);
        }
    };

    this.infoModalDelegatedEvent = function(event) {
        event.preventDefault();

        const nodeId = (this.dataset.source === "" || this.dataset.source === undefined) ? this.dataset.nodeId : _this.getNodeIdFromParentLevel.call(this, 1);
        _this.navTreeInfoModal(nodeId, this.dataset.source);
    };

    this.fullHierarchyInfoModalEvent = function(event) {
        event.preventDefault();

        const infoNodeId = this.closest(".tree-nav-dir").id.replace('category-tree-', '');
        const baseNodeId = this.closest("[data-level='1']").querySelector("[data-node-id]").dataset.nodeId;
        _this.navTreeInfoModal(baseNodeId, infoNodeId);
    };

    this.getNodeIdFromParentLevel = function(depth) {

        const li = this.closest('li.tree-nav-dir[data-level="' + depth + '"]');
        const div = li && li.querySelector('.menu-item') || null;

        if (!div) {
            return this.dataset.nodeId;
        }

        return div.dataset.nodeId;
    };

    this.sourceModalDelegatedEvent = function(event) {
        event.preventDefault();

        const nodeId = this.dataset.source === "" ? this.dataset.nodeId : _this.getNodeIdFromParentLevel.call(this, 1);

        _this.navTreeSourceModal(nodeId, this.dataset.source);
    };

    this.forbiddenModalDelegatedEvent = function(event) {
        event.preventDefault();

        const nodeId = this.dataset.source === "" ? this.dataset.nodeId : _this.getNodeIdFromParentLevel.call(this, 1);

        _this.navTreeForbiddenModal(nodeId, this.dataset.source);
    };

    this.breadcrumbDelegatedEvent = function(event) {
        event.preventDefault();
        event.navtree = {
            closeNavTree: false
        };

        fullHierarchyPath.length = Math.max(parseInt(this.dataset.depth) -1, 0);

        if (fullHierarchyMode) {
            _this.slideTo(parseInt(this.dataset.depth));
            return;
        }

        _this.goto(this.dataset.levelId);
    };

    this.highlightActiveNode = function(elem, clearOthers) {
        if (clearOthers) {
            const currentActive = element.querySelectorAll(".menu-item.active");
            for (let i = 0; i < currentActive.length; i++) {
                if (currentActive[i].classList) {
                    currentActive[i].classList.remove("active");
                }
            }
        }

        if (!elem) {
            return;
        }

        elem.classList.add("active");
    };

    this.getBreadcrumbSummary = function() {
        const thisBreadcrumb = breadcrumbs[treeId].getElementsByTagName("ol")[0];
        return Array.prototype.slice.call(thisBreadcrumb.querySelectorAll('li')).map(function(crumb) {
            const node = {
                id: crumb.dataset.levelId,
                label: crumb.querySelector('span').innerText.trim(),
                depth: crumb.dataset.depth
            };
            const icon = crumb.querySelector('svg.crumb-icon > use');

            if (icon) {
                node.icon = icon.href.baseVal;
            }

            return node;
        });
    };

    this.leafNodeDelegatedEvent = function(event) {
        if (event.target.matches("[data-hash]") || event.target.matches("[data-info]") || event.target.matches("[data-source]") || this.parentNode.classList.contains("disabled")) {
            return;
        }
        event.preventDefault();

        if (!event.ctrlKey) {
            _this.highlightActiveNode(this, true);
        }

        const endpointClick = events.fire(window, "navtree.endpoint_click", {
            cancelable: true,
            detail: {
                node: event.target,
                originalEvent: event,
                levelId: this.dataset.nodeId.substring(0, this.dataset.nodeId.lastIndexOf('_')),
                nodeId: this.dataset.nodeId,
                url: this.dataset.url
            }
        });

        if (endpointClick.defaultPrevented === false) {
            _this.usageLog(this.dataset.nodeId);
            const url = this.dataset.url;
            const target = this.dataset.target;
            const newTab = event.ctrlKey || target;

            setTimeout(function() {
                _this.openUrl(url, newTab);
            }, 1000);
        }
    };

    this.openUrl = function(url, openInNewTab) {
        if (openInNewTab) {
            window.open(url, "_blank");
        } else {
            location.href = url;
        }
    };

    this.goto = function(levelId, activeNode, bigJump) {
        if (activeNode) {
            navTreeActiveNode = activeNode;
        }

        return _this.navTreeJumpToLevel(levelId, bigJump);
    };

    this.preload = function(levelId) {
        return _this.loadLevel(levelId);
    };

    this.slideTo = function(depth) {
        element.dataset.currentLevel = depth + 1;
        navTreeCurrentDepth = depth;
        if (navTreeCurrentDepth < 1) {
            _this.setBackButtonVisibility("top");
            _this.showRootLevelPlaceHolder("block");
            _this.showNavTreeBreadCrumbContainer("none");
        } else {
            _this.showRootLevelPlaceHolder("none");
            _this.showNavTreeBreadCrumbContainer("block");
        }
        _this.sweepLegacyRedundantCrumbs(treeId, depth);
        return _this;
    };

    this.showSectionHierarchyUpto = function(fullHierarchyNodeId) {
        const openNodes = element.getElementsByClassName("open");
        const fullHierarchyNode = document.getElementById("category-tree-" + fullHierarchyNodeId);

        for (let i = 0; i < openNodes.length; i++) {
            openNodes[i].classList.remove("open");
        }

        let elem = fullHierarchyNode;

        while (elem) {
            elem.classList.add("open");
            elem = elem.parentNode.closest(".tree-nav-dir");
        }

        return this;
    };

    this.createBackdrop = function() {
        const el = document.createElement("label");
        el.setAttribute('for', 'nav-open-none');
        el.classList.add("navtree-popup-backdrop");
        return el;
    };

    this.open = function() {
        navtreeOn.checked = true;
        // this.opened();
        return this;
    };

    this.close = function() {
        navtreeOff.checked = true;
        // _this.closed();
        return this;
    };

    this.buildLevelNode = function(idString) {
        const li = document.createElement("li");
        li.classList.add("tree-nav-dir");
        li.id = "category-tree-" + idString;
        li.dataset.level = idString.split("_").length;
        const div = document.createElement("div");
        div.classList.add("menu-item", idString);
        div.id = "nt_node_" + idString;
        div.dataset.nodeId = idString;
        li.appendChild(div);
        return li;
    };

    this.buildBreadcrumbStuctureTo = function(nodeId) {
        let nodes = nodeId.split("_");
        let stringId = "";

        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i] === "top") {
                continue;
            }
            stringId += nodes[i];

            let levelNode = document.getElementById("category-tree-" + stringId);
            _this.addCrumb(levelNode.querySelector(".menu-item"), treeId, stringId.split("_").length, stringId);

            stringId += "_";
        }
    };

    this.buildHierarchyStructureTo = function(nodeId) {
        if (nodeId === "top") {
            return;
        }
        let nodes = nodeId.split("_");
        let elem = document.getElementById("nav-tree-nodes-container").getElementsByTagName("ul")[0];
        let stringId = "";

        for (let i = 0; i < nodes.length; i++) {
            stringId += nodes[i];

            let levelNode = document.getElementById("category-tree-" + stringId);
            if (levelNode === null) {
                levelNode = _this.buildLevelNode(stringId);
                elem.appendChild(levelNode);
            }
            levelNode.classList.add("open");

            let subLevelElement = _this.getSubLevelElement(stringId);
            subLevelElement.setAttribute("data-children", "");

            if (i === nodes.length - 1) {
                return;
            }

            let subLevelList = subLevelElement.querySelector("ul");

            if (subLevelList && subLevelList[0]) {
                elem = subLevelList[0];
            } else {
                subLevelList = document.createElement("ul");
                subLevelElement.appendChild(subLevelList);
            }
            elem = subLevelList;

            stringId += "_";
        }
    };

    this.isAncestorOf = function(elem, ancestorCandidate) {
        if (elem === ancestorCandidate) {
            return true;
        }

        let test = elem;

        while (test !== element) {
            if (test.parentNode === ancestorCandidate) {
                return true;
            }

            test = test.parentNode;
        }

        return false;
    };

    this.fullHierarchyDelegatedEvent = function(event) {

        if (event.target.closest(".tree-nav-q") || event.target.matches(".info")) {
            return;
        }

        fullHierarchyMode = true;

        _this.slideTo(parseInt(this.dataset.level));

        let openLevels = element.querySelectorAll(".tree-nav-dir");
        for (let i in openLevels) {

            if (openLevels[i].classList === undefined) {
                continue;
            }

            if (_this.isAncestorOf(this, openLevels[i])) {
                openLevels[i].classList.add("open");
            } else {
                openLevels[i].classList.remove("open");
            }
        }

        fullHierarchyPath.push(this.id);

        let parent = this.parentElement;
        let positionId = this.id.replace("category-tree-", "");
        while(parent.id !== "category-tree-surveys") {
            if (parent.tagName.toLowerCase() == "li") {
                positionId = parent.id.replace("category-tree-", "") + "_" + positionId;
            }
            parent = parent.parentElement;
        }
        positionId = "surveys_" + positionId;
        _this.usageLog(positionId);

        _this.addCrumb(this.querySelector(".menu-item"), treeId, this.dataset.level, this.id);
    };

    this.surveysQuestionClickedDelegatedEvent = function(event) {
        if (event.target.matches("[data-hash]") || event.target.matches("[data-info]") || event.target.matches("[data-source]")) {
            return;
        }

        let parent = this.parentElement;
        let positionId = this.dataset.id.replace("_", "/");
        for (let i = 0; i < 20; i++) {
            //silly loop but I need to replace all _ and not only first one
            positionId = positionId.replace("_", "/");
        }

        while(parent.id !== "category-tree-surveys") {
            if (parent.tagName.toLowerCase() == "li") {
                positionId = parent.id.replace("category-tree-", "") + "_" + positionId;
            }
            parent = parent.parentElement;
        }
        positionId = "surveys_" + positionId;
        _this.usageLog(positionId);

        if (surveysUrl.indexOf(location.protocol + '//' + location.hostname) === 0) {
            location.hash = this.dataset.hash;

            navTreeActiveNode = this.dataset.id;
            _this.highlightActiveNode(this.querySelector(".menu-item"), true);

            _this.close();
        } else {
            const hash = this.dataset.hash;
            setTimeout(function(){
                _this.openUrl(surveysUrl + "#" + hash, event.ctrlKey);
            }, 1000);
        }
    };

    this.getActiveNodeMenuElement = function() {
        if (surveysUrl.includes(location.hostname) && location.hash) {

            const selector = fullHierarchyPath.map(function(v) {
                return '.' + v;
            }).join(' ');

            return element.querySelector(selector + "[data-hash='" + location.hash.substr(1) + "'] > .menu-item, [data-hash='" + location.hash.substr(1) + "'] > .menu-item");
        }

        return element.querySelector("[data-node-id='" + navTreeActiveNode + "']");
    }

    this.init = function(labels, dispatcher) {
        breadcrumbLabels = labels;
        navtreeOn = document.getElementById("nav-open-navtree");
        navtreeOff = document.getElementById("nav-open-none");
        backdrop = this.createBackdrop();
        document.body.appendChild(backdrop);
        element = document.querySelector("nav.tree-nav-browser");
        breadcrumbs = document.getElementsByClassName("popout-breadcrumb");
        navTreeCurrentDepth = parseInt(element.dataset.currentLevel);

        this.buildHierarchyStructureTo(navTreeStartLevel);
        const firstLoadedNode = this.goto(navTreeStartLevel);

        dispatcher.on("fire_source_popup", (data) => {
            this.navTreeInfoModal(data.id);
        });

        events.addEvent(element, "click", function(event) {
            events.delegateEvents.call(this, event, {
                "[data-children]": _this.traverseForwardDelegatedEvent,
                "[data-info]": _this.infoModalDelegatedEvent,
                "[data-url]:not([data-children])": _this.leafNodeDelegatedEvent,
                "[data-source]": _this.sourceModalDelegatedEvent,
                "[data-full-hierarchy]": _this.fullHierarchyDelegatedEvent,
                "[data-hash]": _this.surveysQuestionClickedDelegatedEvent,
                "[data-forbidden]": _this.forbiddenModalDelegatedEvent,
                "[data-full-hierarchy] .info": _this.fullHierarchyInfoModalEvent
            });
        });

        events.addEvent(breadcrumbs[0], "click", function(event) {
            events.delegateEvents.call(this, event, {
                "[data-level-id]": _this.breadcrumbDelegatedEvent
            });
        });

        events.addEvent(document.getElementById("app-logo"), "click", function() {
            if (!navtreeOn.checked) {
                navtreeOn.checked = true;
            }
        });

        events.addEvent(document.getElementById("nav-tree-back"), "click", function(event) {
            if (fullHierarchyMode) {
                _this.slideTo(navTreeCurrentDepth - 1);
                if (fullHierarchyPath.length) {
                    fullHierarchyPath.pop();
                }

                let positionId = "surveys";
                fullHierarchyPath.forEach(function(element) {
                    positionId+= "_" + element.replace("category-tree-", "");
                });
                _this.usageLog(positionId);
            } else {
                _this.navTreeJumpToParentLevel(
                    _this.navTreeGetParentLevel(navTreeCurrentLevel)
                );
                _this.sweepRedundantCrumbs();
            }
        });

        firstLoadedNode.then(function() {
            _this.highlightActiveNode(_this.getActiveNodeMenuElement());

            for (let i = 0; i < hooks.onReady.length; i++) {
                hooks.onReady[i]();
            }
        })
    }
};
